import { useQuery, UseQueryOptions } from 'react-query';
import { queryKey } from 'constants/queryKey';
import PostApi, { PostScheduleValidation } from 'api/post';
import { PostDetail } from 'types/PostDetail';
import { ApiClientError } from 'api/client';
import { QueryKeyType } from 'app/utils/queryKey';
import useQueryNoCache from 'utils/hooks/useQueryNoCache';

export const usePostQuery = (
  postId: number,
  queryOptions?: {
    common?: {
      refetchInterval?: number;
      cacheTime?: number;
      staleTime?: number;
      enabled?: boolean;
    };
    postDetail?: UseQueryOptions<
      PostDetail,
      ApiClientError,
      PostDetail,
      QueryKeyType
    >;
    postScheduleValidation?: UseQueryOptions<
      PostScheduleValidation,
      ApiClientError,
      PostScheduleValidation,
      QueryKeyType
    >;
  },
) => {
  const postDetail = useQueryNoCache(
    queryKey.postDetail(postId),
    () => PostApi.detail(postId),
    {
      ...queryOptions?.common,
      ...queryOptions?.postDetail,
    },
  );

  const postScheduleValidation = useQuery(
    queryKey.postScheduleValidation(postId),
    () => PostApi.validate([postId]).then((res) => res[0]),
    {
      ...queryOptions?.common,
      ...queryOptions?.postScheduleValidation,
    },
  );

  return {
    postDetail,
    postScheduleValidation,
  };
};
